import React, { useEffect } from 'react';
import CountButton from '../../../../../Components/CountButton/CountButton';
import { Button } from '../../../../../Components/StyledComponents';
import './PointRate.scss';
import {cloneDeep} from 'lodash-es';

const PointRate = ({ deliveryPoint, pickupPoint, tablePoint, patchPoint }) => {
    const [ delivery, setDelivery ] = React.useState(5)//배달 적립 비율
    const [ pickup, setPickup ] = React.useState(5)//포장 적립 비율
    const [ table, setTable ] = React.useState(3)//테이블 적립 비율

    useEffect(() => {
        if(typeof deliveryPoint !== 'undefined') setDelivery(cloneDeep(deliveryPoint))
        if(typeof pickupPoint !== 'undefined') setPickup(cloneDeep(pickupPoint))
        if(typeof tablePoint !== 'undefined') setTable(cloneDeep(tablePoint))
    },[])

    return (
        <div className='point-rate'>
            <div className='row'>
                <p className='modal-title'>배달 주문 적립 비율 (%)</p>
                <CountButton value={delivery} setValue={(val) => setDelivery(val)} min={5} max={10}/>
            </div>
            <div className='divider' />

            <div className='row'>
                <p className='modal-title'>포장 주문 적립 비율 (%)</p>
                <CountButton value={pickup} setValue={(val) => setPickup(val)} min={5} max={10}/>
            </div>
            <div className='divider' />

            <div className='row'>
                <p className='modal-title'>테이블 주문 적립 비율 (%)</p>
                <CountButton value={table} setValue={(val) => setTable(val)} min={1} max={10}/>
            </div>

            <div className='btn-row'>
                <Button variant="main" className='save-btn' fontSize={16} onClick={() => patchPoint(delivery,pickup,table)}>
                    저장하기
                </Button>
            </div>
        </div>
    )
}

export default PointRate;